import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { SystemService } from './system.service';
import { LoaderService } from './loader.service';
import { API_URL, skipUrl } from 'common/constants/sm-constants';

@Injectable()
export class InterceptorService implements HttpInterceptor {
    private totalRequests = 0;
    private errorCount = 0;
    private silentRequests = 0;

    private showToaster: boolean = true;
    private errorMessage: string | null = null;

    constructor(private ss: SystemService, private loadingService: LoaderService) { }

    isMaintenanceRequest(url: string): boolean {
        return url.includes('/appVersion/getall');
    }


    // intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     this.totalRequests++;
    //     this.loadingService.setLoading(true);
    //     request = this.addAuthHeader(request);
    //     return next.handle(request).pipe(
    //         catchError((error: HttpErrorResponse) => this.handleError(error, request, next)),
    //         finalize(() => {
    //             this.totalRequests--;
    //             if (this.totalRequests === 0) {
    //                 this.loadingService.setLoading(false);
    //             }
    //             if (this.errorCount > 0) {
    //                 this.showToaster ? this.ss.showError(this.errorMessage ?? 'Something went wrong') : console.info(this.errorMessage ?? 'Something went wrong');
    //                 this.errorCount = 0;
    //             }
    //         })
    //     );
    // }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isSilentRequest = this.isMaintenanceRequest(request.url);

        if (!isSilentRequest) {
            this.totalRequests++;
            this.loadingService.setLoading(true);
        } else {
            this.silentRequests++;
        }

        request = this.addAuthHeader(request);

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => this.handleError(error, request, next)),
            finalize(() => {
                if (isSilentRequest) {
                    this.silentRequests--;
                } else {
                    this.totalRequests--;
                    if (this.totalRequests === 0) {
                        this.loadingService.setLoading(false);
                    }
                }

                if (this.errorCount > 0) {
                    if (this.showToaster) {
                        this.ss.showError(this.errorMessage ?? 'Something went wrong');
                    } else {
                        console.info(this.errorMessage ?? 'Something went wrong');
                    }
                    this.errorCount = 0;
                }
            })
        );
    }

    private addAuthHeader(request: HttpRequest<any>): HttpRequest<any> {
        const token = this.ss.getlocalStorage('token');
        const shouldSkip = skipUrl.some(url => request.url === url);
        if (token && !shouldSkip) {
            return request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
        }
        return request;
    }

    private handleError(error: HttpErrorResponse, request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        this.errorCount++;

        if (error.status === 401 && !request.url.includes(API_URL.generateApplicationToken)) {
            this.errorMessage = error.error?.error || 'Unauthorized access';
            if (this.errorMessage === 'Unauthorized access') {
                this.showToaster = false;

            } else {
                this.showToaster = true;
            }
            this.ss.clearLocalStorage();
            this.ss.navigateToLogin();
            return throwError(() => new Error(this.errorMessage));
        } else if (error.status === 500) {
            this.handleOtherErrors(error);
            return throwError(() => new Error(this.errorMessage ?? ''));
        } else {
            this.handleOtherErrors(error);
            return throwError(() => new Error(this.errorMessage ?? ''));
        }
    }

    private handleOtherErrors(error: HttpErrorResponse): void {
        if (error.error && typeof error.error === 'object') {
            const { status, msg, error: errorMsg } = error.error;

            if (status == 'Success') {
                // console.log(status,"SUCCESSFULLY");

                // For successful responses, set a positive message
                this.errorMessage = msg || 'Operation completed successfully.';
            } else if (status == 'Failed') {
                // For failed responses, use the error message
                this.errorMessage = errorMsg || 'An unexpected error occurred.';
            } else {
                // For unexpected response statuses
                this.errorMessage = 'Something went wrong.';
            }
        } else {
            // Fallback for unexpected error formats
            this.errorMessage = error.message || 'Unknown error occurred.';
        }

        console.error('Error occurred:', this.errorMessage, error);
    }
}
